import { Edit } from "@mui/icons-material";
import { CircularProgress } from "@mui/material";
import { type FC, useEffect, useState } from "react";
import { SystemValidationTextField } from "../../components/UIToolkit/Inputs/SystemValidationTextField";
import type { DisciplinaryViolation } from "../../utils/models";
import { useSaveDisciplinaryNote } from "./useDisciplinaryReport";

type Props = {
	violation: DisciplinaryViolation;
};

export const EditDisciplinaryNote: FC<Props> = ({ violation }) => {
	const { mutateAsync: saveNote, isPending } = useSaveDisciplinaryNote();
	const [value, setValue] = useState<string>(violation.notes ?? "");
	const [hovered, setHovered] = useState(false);

	useEffect(() => {
		setValue(violation.notes ?? "");
	}, [violation.notes]);

	const persist = async () => {
		const trimmed = value.trim();
		if (trimmed === (violation.notes ?? "")) return;
		await saveNote({
			shiftId: violation.shiftId,
			shiftActualId: violation.shiftActualId,
			violationType: violation.violationType,
			notes: trimmed || null,
		});
	};

	return (
		<SystemValidationTextField
			variant={"standard"}
			value={value}
			onChange={(e) => setValue(e.target.value)}
			inputSx={{ px: 1 }}
			inputProps={{
				disableUnderline: !hovered,
				onMouseEnter: () => setHovered(true),
				onMouseLeave: () => setHovered(false),
				onBlur: persist,
				endAdornment: isPending ? (
					<CircularProgress size={"12px"} />
				) : (
					<Edit sx={{ fontSize: 16, color: "#4D5579", opacity: hovered ? 0.7 : 0, marginLeft: "auto", transition: "opacity 0.2s ease" }} />
				),
			}}
			onKeyDown={async (e) => {
				if (e.key === "Enter") {
					await persist();
				} else if (e.key === "Escape") {
					setValue(violation.notes ?? "");
				}
			}}
			placeholder={"Add note..."}
			fullWidth
			reserveHeightForHelperText={false}
		/>
	);
};
